/**
 * Build com `VITE_SYNAP_SCREENSHOT_FIXTURES=true` (ver `npm run build:screenshots`):
 * repositórios devolvem dados determinísticos em memória — sem escrita na BD.
 * Playwright usa o mesmo bundle em `vite preview` para capturar PNGs em `docs/screenshots/`.
 */
export function isScreenshotFixtureMode(): boolean {
  return import.meta.env.VITE_SYNAP_SCREENSHOT_FIXTURES === 'true'
}

/** sessionStorage — definido pelo Playwright antes do primeiro paint. */
export const SYNAP_SCREENSHOT_PERSONA_KEY = 'synap-screenshot-persona'

/** Playwright: não auto-logar médico mock (ex.: fluxos de login OAuth). */
export const SYNAP_SCREENSHOT_SKIP_AUTO_SESSION_KEY = 'synap-screenshot-skip-auto-session'

export function shouldSkipScreenshotAutoSession(): boolean {
  if (typeof window === 'undefined') return false
  try {
    return window.sessionStorage.getItem(SYNAP_SCREENSHOT_SKIP_AUTO_SESSION_KEY) === '1'
  } catch {
    return false
  }
}

export type SynapScreenshotPersona = 'doctor' | 'system_admin'

export function getScreenshotPersona(): SynapScreenshotPersona {
  if (typeof window === 'undefined') return 'doctor'
  try {
    const v = window.sessionStorage.getItem(SYNAP_SCREENSHOT_PERSONA_KEY)
    if (v === 'system_admin') return 'system_admin'
  } catch {
    /* ignore */
  }
  return 'doctor'
}
